import styled from 'styled-components'

import AutoComplete from '../views/AutoComplete'

export const ProgramAutoComplete = styled(AutoComplete)`
  margin-right: 40px;
  width: 21%;
`
